import { render, staticRenderFns } from "./changeHistory.vue?vue&type=template&id=649e1be9&scoped=true"
import script from "./changeHistory.vue?vue&type=script&lang=js"
export * from "./changeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e1be9",
  null
  
)

export default component.exports